import { useTranslation } from "react-i18next";
import { enUS, mk, sr } from "date-fns/locale";
import type { Locale } from "date-fns";

/**
 * Returns the date-fns Locale object that matches the current i18n language.
 * Used so that format() / parseISO() output uses translated month + day names.
 */
export function useDateLocale(): Locale {
  const { i18n } = useTranslation();
  const lang = (i18n.resolvedLanguage ?? i18n.language ?? "en").split("-")[0];
  switch (lang) {
    case "mk": return mk;
    case "sr": return sr;
    default:   return enUS;
  }
}
